(ns dashboard.events.organizations
  (:require
   [re-frame.core :as re-frame]
   [graphql-query.core :refer [graphql-query]]
   [dashboard.interceptors :refer [standard-interceptors]]
   [ajax.core :as ajax]))

(def organization-fields
  [:id :name])

;; Get

(defn get-organization-query
  [{:keys [uid]}]
  {:operation {:operation/type :query
               :operation/name :getOrganization}
   :queries [[:getOrganization
              {:uid uid}
              organization-fields]]})

(re-frame/reg-event-fx
 ::get-organization
 standard-interceptors
 (fn [{:keys [db]} [uid]]
   {:graphql-request {:query (graphql-query (get-organization-query {:uuid ""}))
                      :on-success [::get-organization-success]}}))

(re-frame/reg-event-fx
 ::get-organization-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (js/console.log res)))

;; Create

(defn create-organization-query
  [{:keys [organization]}]
  {:operation {:operation/type :mutation
               :operation/name :createOrganization}
   :queries [[:createOrganization
              {:input organization}
              organization-fields]]})

(re-frame/reg-event-fx
 ::create-organization
 standard-interceptors
 (fn [{:keys [db]} [{:keys [organization]}]]
   {:graphql-request {:query (graphql-query (create-organization-query
                                             {:organization organization}))
                      :on-success [::create-organization-success]}}))

(re-frame/reg-event-fx
 ::create-organization-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (js/console.log res)))
